import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20modern%20creative%20studio%20with%20multiple%20large%20screens%20displaying%20video%20editing%20timelines%2C%20abstract%20flowing%20particles%20representing%20collaboration%2C%20warm%20orange%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20professional%20video%20production%20environment%2C%20clean%20minimalist%20aesthetic%2C%20depth%20of%20field&width=1800&height=900&seq=hero-bg-yiqicao&orientation=landscape"
          alt="一起草视频 - 视频协作创作平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-sparkling-2-line text-sm text-accent-400"></i>
          <span className="text-xs font-medium text-white/90">2026全新版本 · 协作体验全面升级</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
          视频创作，从<span className="text-primary-400">单打独斗</span>
          <br />到<span className="text-accent-400">团队协作</span>的进化
        </h1>

        <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          一起草视频是专为内容创作者、团队和品牌打造的视频协作创作平台，支持多人实时共同编辑、草稿管理与一键发布，让你的视频创作体验更高效、更流畅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            免费开始使用
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/25 text-white font-medium text-sm hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-down-line"></i>
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12 text-white/60 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-sm text-accent-400"></i>
            <span>企业级安全</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-flashlight-line text-sm text-accent-400"></i>
            <span>毫秒级同步</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-global-line text-sm text-accent-400"></i>
            <span>全球CDN加速</span>
          </div>
        </div>
      </div>
    </section>
  );
}